import { ContextStore } from '../store/contextStore';
import { Helmet } from 'react-helmet-async';
import { useContext } from 'react';

const PageMeta = (props) => {
    const { tourOperator } = useContext(ContextStore);
    const tour_operator = tourOperator;

    return (
        <Helmet>
            <title>
                {tour_operator.name || ""}
                {props.title ? ` - ${props.title}` : null}
            </title>
            {/* Now handled in menu.js (and Badger.js) */}
            {/*<link rel="icon" type="image/png" href={img} sizes="16x16" />*/}
        </Helmet>
    );
};

export default PageMeta;
